import { render, staticRenderFns } from "./CsScrollShadow.vue?vue&type=template&id=1f72f409&"
import script from "./CsScrollShadow.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsScrollShadow.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CsScrollShadow.vue?vue&type=style&index=0&id=1f72f409&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports